import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawGoogleIcon from "./RawGoogleIcon.svg.jsx";

const GoogleIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawGoogleIcon} {...props} />;
});

export default GoogleIcon;
